<div class="mt-1" style="padding: 0 60px;">
    <form [formGroup]="datosFormulario">
        <div class="row">
            <div class="col-12 col-lg-4">
                <h6 style="color:#126db3;margin-left:-15px"> {{"action_plan.title" | translate}}
                </h6>
            </div>
        </div>
        <div class="row mb-2 mb-lg-4">

            <div class="col-12 col-xl-5">
                <div class="input-group search-input" style="margin-left: -15px;">

                    <input class="form-control" #nombre [ngClass]="{ 'error': (datosFormulario.get('nombre').hasError('required') || datosFormulario.get('nombre').hasError('maxlength') || datosFormulario.get('nombre').hasError('pattern') ) &&
                    datosFormulario.get('nombre').touched }" type="text" formControlName="nombre" (keyup)="changes()"
                        (input)="inputEvent()" [readOnly]="fromHistoric" />
                    <div class="input-group-append mr-lg-2">

                        <span class="input-group-text">
                            <button class="fa-stack fa-1x cursor" style="font-size: 13px;border:transparent"
                                (click)="openConfiguration()" #botonConfig>

                                <i class="fa fa-circle fa-stack-2x icon-background"></i>
                                <i class="fas fa-cog fa-stack-1x"></i>
                            </button>
                        </span>

                    </div>
                </div>
                <span class="error text-danger" *ngIf="datosFormulario.get('nombre').hasError('maxlength')  &&
                (datosFormulario.get('nombre').touched ||  datosFormulario.get('nombre').dirty)">
                    {{errorMaxLength}} (144)
                </span>
            </div>
        </div>

        <h6 style="color:#126db3;margin-left:-15px">{{"action_plan.problem_definition.title" | translate}}</h6>
        <div class="row mb-2 bg-white p-4">
            <div class="col-12 col-lg-6">
                <div class="col-12">
                    <h6 style="color: #126db3;margin-left: -15px;">
                        {{"action_plan.problem_definition.situation" | translate}}</h6>
                </div>

                <textarea maxlength="72" class="form-grey col-12 form-control" formControlName="situacion_tratar" (keyup)="changes()"
                    (input)="inputEvent()" [ngClass]="{ 'error': (datosFormulario.get('situacion_tratar').hasError('required') || datosFormulario.get('situacion_tratar').hasError('maxlength')) &&
                datosFormulario.get('situacion_tratar').touched }" [readOnly]="fromHistoric"></textarea>
                <span class="error text-danger" *ngIf="datosFormulario.get('situacion_tratar').hasError('maxlength')  &&
               ( datosFormulario.get('situacion_tratar').touched || datosFormulario.get('situacion_tratar').dirty)">
                    {{errorMaxLength}} (72)
                </span>

            </div>
            <div class="col-12 col-lg-6">
                <div class="col-12">
                    <h6 style="color: #126db3;margin-left: -15px;">
                        {{"action_plan.problem_definition.objective" | translate}}</h6>
                </div>

                <textarea class="col-12 form-grey form-control" formControlName="objetivo" (keyup)="changes()"
                    (input)="inputEvent()" [ngClass]="{ 'error': datosFormulario.get('objetivo').hasError('required')  &&
                datosFormulario.get('objetivo').touched }" [readOnly]="fromHistoric"></textarea>

            </div>
        </div>
    </form>
</div>